var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-internet-message",class:{
    's-internet-message__variant--low-internet': _vm.internetStatus.speed < 0.5,
  }},[(_vm.internetStatus.speed < 0.5)?_c('span',[_c('i',{staticClass:"icofont-network-tower"}),_vm._v(" "+_vm._s(_vm.$t("lowInternetMessage")))]):(!_vm.internetStatus.connection)?_c('span',[_c('i',{staticClass:"icofont-sad"}),_vm._v(" "+_vm._s(_vm.$t("noInternetMessage")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }